var first_captcha_generated = false;
var captcha_audio = null;
function SystemsightCaptcha(element, options) {
    var defaults = {
        version: '1.0.0',
        placeholder: '/Modules/Captcha/assets/images/captcha-preview.jpg'
    }
    var that = this;
    that.options = $.extend(true, {}, defaults, options);

    that.generated = false;
    that.element = element;
    that.$input = $(element);
    that.$img = that.$input.parent().find('img.captcha-image');
    that.$audioBtn = that.$input.parent().find('[data-action="play"]');
    that.$refreshBtn = that.$input.parent().find('[data-action="refresh"]');

    that.init();
}

SystemsightCaptcha.prototype.initialize = function () {
    var that = this;
    $('input.captcha-input').each(function (){
        if($(this).data('captchaInstance')) return;

        $(this).data('captchaInstance', new SystemsightCaptcha(this));
    })
}
SystemsightCaptcha.prototype.init = function () {
    var that = this;

    console.info('SystemsightCaptcha inited (' + that.options.version + ')');

    if(that.$audioBtn.length)
    {
        that.$audioBtn.data('autoplay', false);
        that.$audioBtn.on('click', function (e) {
            that.$audioBtn.data('autoplay', true);
            if(that.captcha_image_source_exist()){
                that.captcha_play_captcha_audio();
            }
        });
        that.$img.on('load', function (e) {
            if (that.$audioBtn.data('autoplay')) {
                that.captcha_play_captcha_audio();
            }
        });
    }

    that.$input.on('focus', function (e) {
        if(that.generated) return;
        that.captcha_image_source_exist();
    });
    that.$img.on('mouseover', function (e) {
        if(that.generated) return;
        that.captcha_image_source_exist();
    });

    var $collapseWrap = that.$img.closest('.collapse');
    if($collapseWrap.length){
        $collapseWrap.on('shown.bs.collapse', function () {
            if(that.generated) return;
            that.captcha_image_source_exist();
        })
    }

    if(that.$refreshBtn){
        that.$refreshBtn.on('click', function (e) {
            that.doRefresh();
        });
    }
    that.$input.data('refresh', function () {
        that.doRefresh();
    });


    setTimeout(function (){
        if(!first_captcha_generated && that.$input.is(":visible")){
            first_captcha_generated = true
            that.captcha_image_source_exist();
        }
    }.bind(this), 100)

}
SystemsightCaptcha.prototype.captcha_image_source_exist = function () {
    var that = this;
    if(captcha_audio){
        captcha_audio.pause();
        captcha_audio = null;
    }

    if(that.$img.attr('src') === that.options.placeholder){
        //TODO: gal to nereikia, jei naudosim namespace?
        $("img.captcha-image").attr('src', that.options.placeholder)
        that.$img.attr('src', that.$img.data('src') + '?r=' + Math.random());
        that.generated = true;
        return false;
    }
    return true;
}
SystemsightCaptcha.prototype.captcha_play_captcha_audio = function () {
    var that = this;
    if(captcha_audio){
        captcha_audio.pause();
        captcha_audio = null;
    }

    var audioUrl = that.$audioBtn.data('url') + '?r=' + Math.random();
    captcha_audio = new Audio(audioUrl);
    captcha_audio.play();

    $(captcha_audio).on('ended', function (e) {
        that.$audioBtn.find('i.fa').addClass('fa-play-circle-o').removeClass('fa-circle-o-notch fa-spin');
    })

    that.$audioBtn.find('i.fa').removeClass('fa-play-circle-o').addClass('fa-circle-o-notch fa-spin');
    that.$audioBtn.data('autoplay', false);
}
SystemsightCaptcha.prototype.doRefresh = function () {
    var that = this;
    that.$img.attr('src', that.$img.data('src')  + '?r=' + Math.random())
    if(captcha_audio){
        captcha_audio.pause();
        captcha_audio = null;
        if(that.$audioBtn){
            that.$audioBtn.find('i.fa').addClass('fa-play-circle-o').removeClass('fa-circle-o-notch fa-spin');
        }
    }
}

if (typeof module === "object" && typeof module.exports === "object"){
    //node modules support
    SystemsightCaptcha.prototype.initialize();
    module.exports = SystemsightCaptcha
}else{
    $(function(){
        SystemsightCaptcha.prototype.initialize();
    });
}
